import React, { createContext, useContext, useState } from "react";
import { EventEmitter } from "events";
import axios from "axios";

const ProfileContext = createContext();

const ProfileEvents = new EventEmitter();

export const ProfileProvider = ({ children }) => {
  const [profile, setProfile] = useState({});

  const fetchProfile = async () => {
    try {
      const response = await axios.get(`/profile`);
      setProfile(response.data);
      return response;
    } catch (error) {
      console.error("Error fetching profile:", error);
      throw error; // Propagate error to the caller
    }
  };

  const updateProfile = async (updatedData) => {
    try {
      const response = await axios.put(`/profile`, updatedData);
      setProfile(response.data);
    } catch (error) {
      console.error("Error updating profile:", error);
      throw error; // Propagate error to the caller
    }
  };

  const updatePassword = async (passwordData) => {
    try {
      const response = await axios.put(`/profile/password`, passwordData);
      setProfile(response.data);
      return response.data;
    } catch (error) {
      console.error("Error updating password:", error);
      throw error;
    }
  };

  const deleteProfile = async () => {
    try {
      await axios.delete(`/profile`);
    } catch (error) {
      console.error("Error deleting profile:", error);
      throw error;
    }
  };

  const value = {
    profile,
    fetchProfile,
    updateProfile,
    updatePassword,
    deleteProfile,
    ProfileEvents,
  };

  return (
    <ProfileContext.Provider value={value}>{children}</ProfileContext.Provider>
  );
};

// Custom hook to use ProfileContext
export const useProfileContext = () => {
  const context = useContext(ProfileContext);
  if (!context) {
    throw new Error("useProfileContext must be used within a ProfileProvider");
  }
  return context;
};
